import React from 'react'
import {useTranslation} from 'react-i18next'
import styled from 'styled-components'
import TypographyAtom from '../typography/typography.atom'
import internal_server_errorStyles from './internal_server_error.styles'
import SvgIconAtom from '../svg_icon/svg_icon.atom'

const apAtomName = {ap_atom_name: 'apInternalServerErrorAtom'}

const StyledWrapper = styled(props => <section {...props} />)`
  ${internal_server_errorStyles}
`

const InternalServerErrorAtom: React.FC = function () {
  const {t} = useTranslation()

  return (
    <StyledWrapper {...apAtomName}>
      <div>
        <SvgIconAtom ap_type="internalServerError" />
      </div>
      <div>
        <TypographyAtom ap_type="h4">{t('errorPage.title')}</TypographyAtom>
        <TypographyAtom ahd_type="fData">
          {t('errorPage.description')}
        </TypographyAtom>
      </div>
    </StyledWrapper>
  )
}

export default InternalServerErrorAtom
